var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRita3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-forBgDark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 701 176.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#455a64;}.cls-2{fill:#f35899;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M920.7,38.43h59.43c36.87,0,65.54,10.47,65.54,42.34,0,30.65-28.67,44.55-65.54,44.55H952.5V181H920.7Zm56.17,66.62c24.34,0,37.57-8.2,37.57-24.28,0-16.35-13.23-22.07-37.57-22.07H952.5v46.35Zm20.18-1.71L1052.53,181H1017l-42.91-62.46Z",
    transform: "translate(-920.7 -17.93)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1158.44,93.87h-57.69v-20h89.14V181h-31.45Zm-8.68-56.33c0-10,9.41-17,22.34-17s22.34,7,22.34,17S1185,54.38,1172.1,54.38,1149.76,47.73,1149.76,37.54Z",
    transform: "translate(-920.7 -17.93)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1309.5,137.94V93.87h-35.73V75.07l37-1.17,4.09-33.54h26V73.9h60.72v20H1341v44c0,17.69,8.28,25.66,30.85,25.66a101.44,101.44,0,0,0,29-4.31l6.1,18.34c-12,3.17-25.45,6.09-42.73,6.09C1323.4,183.62,1309.5,165.23,1309.5,137.94Z",
    transform: "translate(-920.7 -17.93)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1457,152.24c0-24,26.34-36,92.29-39.69-1.11-12-10-21-31.78-21-15,0-29.9,5.26-43.63,11.37l-11.67-16.69c16.19-7.78,38.09-15,61.1-15,37.07,0,57.44,16.51,57.44,46.34V181h-25.85l-2.4-13.27h-.92c-14,8.68-31.95,15.89-49.84,15.89C1475.73,183.62,1457,170.81,1457,152.24Zm92.29-1.42V128.31c-48,2.53-61.81,10.43-61.81,22,0,9.44,10.4,13.51,23.64,13.51C1524.6,163.8,1537,158.77,1549.32,150.82Z",
    transform: "translate(-920.7 -17.93)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 240.09,
    cy: 88.22,
    r: 88.22
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 682.45,
    cy: 144.52,
    r: 18.55
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "265.36 54.05 270.47 36.23 246.54 26.55 238.66 54.05 265.36 54.05"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "235.01 66.79 218.47 124.55 224.81 152.93 242.08 135.32 261.71 66.79 235.01 66.79"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRita3);
export default __webpack_public_path__ + "static/media/logo-rita-3.664cec370c9a173d24170334e0f53877.svg";
export { ForwardRef as ReactComponent };